var _rect, _path, _path2, _g, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandingAnalyze(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 55,
    viewBox: "0 0 60 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 55,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 0C13.4315 0 0 13.5258 0 30.0943C0 39.3578 4.19854 47.6701 10.7965 53.1991C17.8096 54.7089 28.723 55.8523 35.8297 50.7666C41.5384 46.6813 50.142 44.2195 57.198 42.7882C58.9959 38.9273 60 34.6245 60 30.0943C60 13.5258 46.5685 0 30 0Z",
    fill: "#1DA1F2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_983_1378",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 55
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 0C13.4315 0 0 13.5258 0 30.0943C0 39.3578 4.19854 47.6701 10.7965 53.1991C17.8096 54.7089 28.723 55.8523 35.8297 50.7666C41.5384 46.6813 50.142 44.2195 57.198 42.7882C58.9959 38.9273 60 34.6245 60 30.0943C60 13.5258 46.5685 0 30 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_983_1378)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 18.75C28.4184 18.75 27.3611 19.0707 26.4617 19.6717C25.5624 20.2726 24.8615 21.1267 24.4475 22.1259C24.0336 23.1252 23.9253 24.2248 24.1363 25.2857C24.3473 26.3465 24.8682 27.3209 25.633 28.0857C26.3978 28.8506 27.3723 29.3714 28.4331 29.5824C29.4939 29.7934 30.5935 29.6851 31.5928 29.2712C32.5921 28.8573 33.4462 28.1564 34.0471 27.257C34.648 26.3577 34.9688 25.3004 34.9688 24.2188C34.9688 22.7683 34.3926 21.3773 33.367 20.3518C32.3414 19.3262 30.9504 18.75 29.5 18.75ZM29.5 27.5C28.851 27.5 28.2166 27.3076 27.677 26.947C27.1374 26.5865 26.7169 26.074 26.4685 25.4744C26.2202 24.8749 26.1552 24.2151 26.2818 23.5786C26.4084 22.9421 26.7209 22.3574 27.1798 21.8986C27.6387 21.4397 28.2234 21.1272 28.8599 21.0005C29.4964 20.8739 30.1561 20.9389 30.7557 21.1873C31.3553 21.4356 31.8677 21.8562 32.2283 22.3958C32.5888 22.9354 32.7812 23.5698 32.7812 24.2188C32.7812 25.089 32.4355 25.9236 31.8202 26.5389C31.2048 27.1543 30.3702 27.5 29.5 27.5ZM29.5 12.1875C26.3102 12.1911 23.2521 13.4599 20.9966 15.7154C18.7411 17.9709 17.4724 21.029 17.4688 24.2188C17.4688 28.5117 19.4525 33.0617 23.2109 37.3779C24.8997 39.3283 26.8004 41.0846 28.8779 42.6143C29.0618 42.7431 29.2809 42.8122 29.5055 42.8122C29.73 42.8122 29.9491 42.7431 30.133 42.6143C32.2067 41.0839 34.1037 39.3277 35.7891 37.3779C39.542 33.0617 41.5312 28.5117 41.5312 24.2188C41.5276 21.029 40.2589 17.9709 38.0034 15.7154C35.7479 13.4599 32.6898 12.1911 29.5 12.1875ZM29.5 40.3516C27.24 38.5742 19.6562 32.0459 19.6562 24.2188C19.6562 21.608 20.6934 19.1042 22.5394 17.2582C24.3855 15.4121 26.8893 14.375 29.5 14.375C32.1107 14.375 34.6145 15.4121 36.4606 17.2582C38.3066 19.1042 39.3438 21.608 39.3438 24.2188C39.3438 32.0432 31.76 38.5742 29.5 40.3516Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingAnalyze);
export default __webpack_public_path__ + "static/media/landing_analyze.d23b4c9b2b552ba6218880183dafd093.svg";
export { ForwardRef as ReactComponent };